import { render, staticRenderFns } from "./aidSaleRecord.vue?vue&type=template&id=6234ae53&scoped=true&"
import script from "./aidSaleRecord.vue?vue&type=script&lang=js&"
export * from "./aidSaleRecord.vue?vue&type=script&lang=js&"
import style0 from "./aidSaleRecord.vue?vue&type=style&index=0&id=6234ae53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234ae53",
  null
  
)

export default component.exports